import { Canvas } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { GridContainerBlock, GridItemBlock, InputBlock, LabelBlock, FeedbackMessageBlock, RecaptchaBlock, TextBlock } from "..";
import BasePreview from "../base";

function OptoutFormPreview({ ...props }) {
  return <BasePreview {...props}>
    <div>
      <Canvas
        id="grid-container"
        is={GridContainerBlock}
        properties={{ layoutType: 'grid', grid: { columns: 2, gap: { x: "6-predefined", y: "4-predefined" } } }}>
        {FIELDS.map(field => <Canvas
          key={field.value}
          is={GridItemBlock}
          custom={{ name: `${field.label}` }} >
          <Canvas
            is={LabelBlock}
            properties={{ attributes: { htmlFor: field.value }, content: field.label, fontSize: 'base', textColor: 'gray-700', fontWeight: 'font-bold' }} />
          <Canvas
            is={InputBlock}
            attributes={{ id: field.value, name: field.value, value: `{{data.${field.value}}}`, required: true }}
            properties={{ attributes: { value: '' }, className: 'peer', space: { padding: 'p-2' }, border: { radius: { rounded: 'sm' }, width: { border: '1' }, color: 'gray-400' }, size: { width: 'w-full', height: 'min-h-8' } }} />
          <Canvas
            is={FeedbackMessageBlock}
            properties={{ content: 'Field Required.', space: { padding: 'pt-1' }, fontSize: 'xs', textColor: 'red-400' }} />
        </Canvas>)}
        <Canvas
          is={GridItemBlock}
          custom={{ name: 'Optout' }}
          properties={{ grid: { itemColumn: 2 }, layoutType: 'flex', flex: { direction: 'flex-row', wrap: 'flex-wrap' } }} >
          <Canvas
            is={InputBlock}
            attributes={{ type: 'checkbox', id: 'cbOptout', name: 'optout', required: true }}
            properties={{ className: 'peer', space: { margin: 'mr-2' }, border: { radius: { rounded: "sm" }, width: { border: "1" }, color: "gray-400" }, size: { width: "w-6", height: "h-6" } }} />
          <Canvas
            is={LabelBlock}
            properties={{ attributes: { htmlFor: 'cbOptout' }, content: 'Do not sell my information to third parties.', fontSize: 'base', textColor: 'gray-700', fontWeight: 'font-bold' }} />
          <Canvas
            is={FeedbackMessageBlock}
            properties={{ content: 'You need to check this field.', fontSize: 'xs', textColor: 'red-400' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 2 } }}
          custom={{ name: 'Consent' }}>
          <Canvas
            is={TextBlock}
            properties={{ content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum', fontSize: 'base', textColor: 'gray-900', outline: { outline: 'none' }, textAlign: { horizontal: 'justify' } }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 2 } }}
          custom={{ name: 'Recaptcha' }}>
          <Canvas
            is={RecaptchaBlock} origin="optout" />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ layoutType: 'flex', flex: { distribute: 'justify-center', direction: 'flex-row' }, grid: { itemColumn: 2 } }}
          custom={{ name: 'Submit' }}>
          <Canvas is={InputBlock}
            properties={{ attributes: { value: 'Submit', name: 'submit', type: 'submit' }, className: "cursor-pointer", background: { color: 'blue-500' }, textColor: 'gray-100', space: { padding: 'p-3' }, border: { radius: { rounded: "sm" } }, fontWeight: 'font-bold', size: { width: 'w-md' } }} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

function OptoutFormHTML({ children, attributes }) {
  return <>
    <form {...attributes}
      id="optout-form" method="POST" noValidate>
      {`{{>util/alert-error msg=error}} <input type="hidden" name='forceEmail' value="{{data.forceEmail}}" />`}
      {children}
    </form>
    {`<script>
      (function () {
        var form = document.getElementById('optout-form');
        form.addEventListener('submit', function (event) {
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add('was-validated');
        }, false);
      })();
    </script>`}
  </>
}

export default define('optout-form', OptoutFormPreview, OptoutFormHTML)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .defaultProps({
    size: { width: 'w-full' },
    className: 'needs-validation',
  })
  .build()

const FIELDS = [
  { label: 'First Name', value: 'firstName' },
  { label: 'Last Name', value: 'lastName' },
  { label: 'Street Address', value: 'streetAddress' },
  { label: 'City', value: 'city' },
  { label: 'State', value: 'state' },
  { label: 'Zip/Postal Code', value: 'zip' },
  { label: 'E-mail', value: 'email' },
]
